export default __webpack_public_path__ + "static/media/hotel.3c492635.svg";